// @ts-check
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import operationHasFile from '@bottlebooks/react-common/src/apolloClient/operationHasFile';
import { createUploadLink } from 'apollo-upload-client';
import generated from '../generated/possibleTypes.js';
import typePolicies from './typePolicies';

const graphqlUri = import.meta.env.VITE_GRAPHQL_URI || '/graphql';

// Apollo Server 4 blocks multipart/form-data as potential CSRF unless the request
// carries `apollo-require-preflight`. Adding it only for operations that actually
// have file variables keeps normal queries out of the extra CORS allow-list.
const uploadPreflightLink = new ApolloLink((operation, forward) => {
  if (operationHasFile(operation.variables)) {
    operation.setContext(
      (/** @type {{ headers?: Record<string, string> }} */ prev) => ({
        ...prev,
        headers: { ...(prev.headers || {}), 'apollo-require-preflight': 'true' },
      })
    );
  }
  return forward(operation);
});

export default function createClient() {
  return new ApolloClient({
    cache: new InMemoryCache({
      typePolicies,
      possibleTypes: generated.possibleTypes,
    }),
    link: uploadPreflightLink.concat(
      // @ts-ignore Because the type contracts aren’t nominally equivalent between the official Apollo Client and the object created by createUploadLink (at the moment), we need to use @ts-ignore to prevent type error.
      createUploadLink({
        uri: graphqlUri,
        credentials: 'include',
        // Forces caching of the result although we call Set-Cookie on every request.
        headers: { 'gcdn-force': 1 },
      })
    ),
    // name, version  // if those are provided Cors error is thrown ...
  });
}

